import type { ComponentProps, FunctionComponent } from 'react';

type ISinglePathIcon = ComponentProps<'path'> & {
    path: string;
};

export const SingePathIcon: FunctionComponent<ISinglePathIcon> = ({
    path,
    ...props
}) => (
    <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d={path}
        {...props}
    />
);
